import type { IconDefinition as FontAwesomeIcon } from '@fortawesome/fontawesome-svg-core';
import type { FunctionComponent, SVGProps } from 'react';

export enum SocialName {
  twitter = 'twitter-x',
  facebook = 'facebook',
  linkedin = 'linkedin',
  whatsapp = 'whatsapp',
  telegram = 'telegram',
  reddit = 'reddit',
}

export enum SocialOfficialName {
  twitter = 'Twitter / X',
  facebook = 'Facebook',
  linkedin = 'LinkedIn',
  whatsapp = 'WhatsApp',
  telegram = 'Telegram',
  reddit = 'Reddit',
}

export enum Achievement {
  badge = 'badge',
  room = 'room',
  certificate = 'certificate',
}

export interface CampaignProps {
  utmContent: string;
  utmCampaign?: string;
  utmMedium?: string;
}

export interface LinkProps {
  url: string;
  description: string;
  campaign: CampaignProps;
}

export type SocialLinks = {
  [key in SocialName]?: boolean;
};

export interface PageShareProps extends Omit<LinkProps, 'campaign'> {
  socialLinks?: SocialLinks;
  campaign: CampaignProps;
}

export interface SocialIconLinks {
  href: (pageProps: LinkProps) => string;
  icon: FunctionComponent<SVGProps<SVGSVGElement & { title?: string | undefined }>>;
  faIcon: FontAwesomeIcon;
  name: SocialName;
  officialName: string;
}

export interface DropdownShareProps {
  buttonLabel: string;
  linkMetadata: LinkProps;
  isLoading?: boolean;
  onSelect: (value: SocialName | 'download') => void;
  downloadUrl?: string;
  isDark?: boolean;
  shareableSocials?: SocialName[];
  canCopy?: boolean;
}
